module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"field":{"mode":{"detection":"囲みあり","original":"囲みなし"}}},"en":{"field":{"mode":{"detection":"With highlighted rat movements","original":"Original video"}}}}')
  delete Component.options._Ctor
}
